import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var SentimentVerySatisfied = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.99 2C6.47 2 2 6.47 2 12s4.47 10 9.99 10S22 17.53 22 12 17.52 2 11.99 2zm-4.7 7.41l.89-.88a.996.996 0 011.41 0l.88.88c.29.29.29.77 0 1.06-.29.29-.77.29-1.06 0l-.53-.53-.53.53c-.29.29-.77.29-1.06 0a.754.754 0 010-1.06zm9.46 5.34c-.95 1.64-2.72 2.75-4.75 2.75s-3.8-1.11-4.75-2.75c-.19-.33.06-.75.44-.75h8.62c.39 0 .63.42.44.75zm-.04-4.28c-.29.29-.77.29-1.06 0l-.53-.53-.53.53c-.29.29-.77.29-1.06 0a.746.746 0 01.01-1.06l.88-.88a.996.996 0 011.41 0l.88.88c.29.29.29.77 0 1.06z"
  }));
});
SentimentVerySatisfied.displayName = 'SentimentVerySatisfied';
export var SentimentVerySatisfiedDimensions = {
  height: 24,
  width: 24
};